import {listJobsOverview} from "@/services/api/app/common/jobsInProgress";

const defaultState = () => ({
  jobsInProgress: [],
  filter: {
    ProviderType: 3,
  }
});

export default {
  namespaced: true,
  actions: {
    listJobsOverview({commit, state}) {
      return listJobsOverview(state.filter)
        .then((result) => {
          commit('setJobInProgress', result);
        })
    },
  },

  mutations: {
    setJobInProgress(state, jobsInProgress) {
      state.jobsInProgress = jobsInProgress;
    },
  },

  state: defaultState,
}
